{
    "common": {
        "notification": "Notification"
    },
    "network-status": {
        "offline": "Network connection is unstable",
        "slow": "Network connection is slow",
        "realtime": "Realtime connection is unstable"
    },
    "api-error": {
        "offline": "Unable to reach the server. Please check your connection.",
        "unauthorized": "Your session has expired. Please sign in again.",
        "payload-too-large": "The uploaded file is too large.",
        "unsupported-media-type": "This file type is not supported.",
        "too-many-requests": "Too many requests. Please wait a moment and try again.",
        "unknown": "Something went wrong. Please try again."
    },
    "upload": {
        "image-type-not-allowed": "Only .jpg, .jpeg and .png files are allowed",
        "file-too-large": "The file is larger than {{max}}MB"
    }
}
